(() => {
  function applyFooterHotfix() {
    document.querySelectorAll('.twf-testimonials__reviewer .tw-welcome-offer').forEach((offer) => offer.remove());
    const footer = document.querySelector('.page-wrapper > footer');
    if (footer && !footer.querySelector(':scope > .tw-welcome-offer')) {
      const offer = document.createElement('p');
      offer.className = 'tw-welcome-offer';
      offer.innerHTML = '10% off your first order — use <strong>WELCOME10</strong> · <a href="/discount/WELCOME10?redirect=/collections/all">Shop now</a>';
      footer.prepend(offer);
    }
    document.querySelectorAll('body *').forEach((node) => {
      if (node.children.length || node.textContent.trim().toUpperCase() !== '5% OFF') return;
      const tier = node.closest('[class*="tier"], [class*="quantity"], [class*="bundle"], label, button, li, div');
      if (tier && /BUY\s*2/i.test(tier.textContent || '')) node.textContent = '10% OFF';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFooterHotfix, { once: true });
  else applyFooterHotfix();
  document.addEventListener('shopify:section:load', applyFooterHotfix);
})();
